import { render } from "./BaseLoadingIcon.vue?vue&type=template&id=47bde14d&scoped=true"
import script from "./BaseLoadingIcon.vue?vue&type=script&lang=js"
export * from "./BaseLoadingIcon.vue?vue&type=script&lang=js"

import "./BaseLoadingIcon.vue?vue&type=style&index=0&id=47bde14d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47bde14d"

export default script